import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setWhatsAppNumber } from "@/lib/api";

const SiteContext = createContext({ site: {}, settings: {}, cms: null, reload: () => {} });

export function SiteProvider({ children }) {
  const [cms, setCms] = useState(null);
  const reload = useCallback(() => {
    api.get("/cms/content").then((r) => { setWhatsAppNumber(r.data?.settings?.whatsapp_number); setCms(r.data); }).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return (
    <SiteContext.Provider value={{ cms, site: cms?.site || {}, settings: cms?.settings || {}, reload }}>
      {children}
    </SiteContext.Provider>
  );
}

export function useSite() {
  return useContext(SiteContext);
}
